import React from 'react'

import { FormBuilder, Spinner } from '@acorns/web-components'
import { path } from 'ramda'

import AgreementModal from 'components/AgreementModal'
import Button from 'components/Button'
import CredentialsFormRow from 'components/CredentialsFormRow'
import FormContainer from 'components/FormContainer'
import Layout from 'components/Layout'
import Nav from 'components/Nav'
import Separator from 'components/Separator'
import { withClickTrack } from 'components/Trackers/ClickTracker'
import { TRACKER_IDS } from 'components/Trackers/trackerIDs'

import { TestIDs } from '../../../test/utils/testIds'
import { passwordErrorMap } from '../common/utils'
import { enhance } from './enhance'
import { Props } from './types'
import { INITIAL_VALUES, validationSchema } from './validation'

// Create a trackable Create Account button
const CreateAccountButton = withClickTrack<any, any>(TRACKER_IDS.SIGNUP.CREATE_ACCOUNT_BUTTON)(
  Button,
)

export const Signup: React.SFC<Props> = ({
  closeAgreementModal,
  currentAgreement,
  env,
  errors,
  handleOnLink,
  handleSubmit,
  isLoading,
  isModalOpen,
  isSubmitting,
  isValid,
  onChange,
  onSubmit,
  identityRows,
  disclosureRows,
  setFieldValue,
  values,
  header,
  text,
  heroText,
  pageNotFound,
}) => (
  <>
    <Nav />
    <Layout
      header={heroText.header}
      text={heroText.text}
      footnote={heroText.footnote}
      footnoteLock={heroText.footnoteLock}
      pageNotFound={pageNotFound}
    >
      <FormContainer>
        <FormBuilder
          errors={errors}
          rows={identityRows}
          values={values}
          handleChange={onChange}
          setFieldValue={setFieldValue}
        />

        <CredentialsFormRow
          errors={errors}
          initialValues={INITIAL_VALUES}
          passwordErrorMap={passwordErrorMap}
          setFieldValue={setFieldValue}
          validationSchema={validationSchema}
          values={values}
        />

        <FormBuilder
          errors={errors}
          rows={disclosureRows}
          values={values}
          handleChange={onChange}
          setFieldValue={setFieldValue}
        />
      </FormContainer>

      <Separator />

      <div>
        <CreateAccountButton
          styleType={isValid ? undefined : 'invalid'}
          onPress={onSubmit}
          data-testid={TestIDs.SIGNUP.CREATE_ACCOUNT_BUTTON}
          disabled={isSubmitting}
          buttonType={'submit'}
        >
          {isSubmitting ? <Spinner height={20} width={20} white={true} /> : 'Create account'}
        </CreateAccountButton>
      </div>

      <AgreementModal
        title={path(['name'], currentAgreement)}
        isOpen={isModalOpen}
        onCloseClick={closeAgreementModal}
      >
        {isLoading ? <Spinner height={50} width={50} /> : path(['document'], currentAgreement)}
      </AgreementModal>
    </Layout>
  </>
)

export default enhance(Signup)
